import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../../assets/Icons";
import EditCommonPopup from "../../../../../components/_utils/CommonPopups/CommonEditPopup";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import {
  approveBeneficiaryAccount,
  beneficiaryAccountDetailsById,
  rejectBeneficiaryAccount,
} from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  bankLookUp,
  panLookUp,
} from "../../../../../redux/features/sharedResources/sharedResources";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import accountNameStandardised from "../../../../../utils/accountNamestandardised";
import globalText from "../../../../../utils/globalText.js";

/* We need to call beneficiary account APIs here since after bank account update is
successful, reimbursement account turns into beneficiary account.
*/
function ReimbursementBankEditSucess() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const updatedFields = location?.state?.updatedFields || [];
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    gstin_no: "",
    contact_no: "",
    email_id: "",
    labels: "",
  });
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [showSwitchAccountModal, setShowSwitchAccountModal] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const { beneficiaryAccountDetailsData } = useSelector(
    (state) => state.beneficiaryAccount,
  );
  const { panLookupData, bankLookupData } = useSelector(
    (state) => state.sharedResources,
  );
  const beneAccountSuccessData =
    beneficiaryAccountDetailsData?.beneficiary_accounts[0];

  useEffect(() => {
    if (beneAccountSuccessData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
        gstin_detail,
        contact_no,
        email_id,
      } = beneAccountSuccessData;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels,
        gstin: gstin_detail,
        contact_no,
        email_id: email_id,
      });
    }
  }, [beneAccountSuccessData]);

  const createTxn = () => {
    navigate(
      `/beneficiary_transaction_dashboard/create_beneficiary_transaction`,
      {
        state: currentAccountDetails,
        replace: true,
      },
    );
  };
  const switchAccountType = () => {
    // dispatch(resetInEdit());
    setShowSwitchAccountModal(true);
  };
  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_account_dashboard", {
      replace: true,
    });
  };

  const handleChipClick = (id) => {
    if (selectedChipIndex === id) {
      setSelectedChipIndex(null);
    } else {
      setSelectedChipIndex(id);
    }
  };

  useEffect(() => {
    dispatch(beneficiaryAccountDetailsById({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (!beneAccountSuccessData) return;

    dispatch(panLookUp({ pan_number: beneAccountSuccessData.pan_no }));

    dispatch(
      bankLookUp({
        ifsc: beneAccountSuccessData.ifsc_code,
        bank_account_no: beneAccountSuccessData.bank_acc_no,
      }),
    );
  }, [beneAccountSuccessData, dispatch]);

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : [
          "bank_account_holder_name",
          "bank_acc_no",
          "ifsc_code",
          "virtual_account_type",
        ];

  const bankFieldConfig = {
    // bank_account_holder_name: {
    //   leftSubTitle: "Account name",
    //   getTitle: (acc) => acc?.name,
    // },
    bank_acc_no: {
      leftSubTitle: "Account number",
      getTitle: (acc) => formatAccountNumber(acc?.bank_acc_no),
      ifsc: (acc) => acc?.ifsc_code,
    },
    ifsc_code: {
      leftSubTitle: globalText?.IFSC,
      getTitle: (acc) => acc?.ifsc_code,
    },
    virtual_account_type: {
      leftSubTitle: "Virtual account",
      getTitle: (acc) =>
        acc?.virtual_account_type === "automated"
          ? "Auto detected"
          : acc?.virtual_account_type === "manual"
            ? "Manually created"
            : null,
    },
  };

  const renderBankCards = () => {
    return fieldsToShow
      .filter((key) => bankFieldConfig[key])
      .map((key) => {
        const config = bankFieldConfig[key];
        const title = config.getTitle(beneAccountSuccessData);

        if (title === null || title === undefined) return null;
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: config.getTitle(beneAccountSuccessData),
                leftSubTitle: config.leftSubTitle,
                ...(config.ifsc && {
                  ifsc: config.ifsc(beneAccountSuccessData),
                }),
              },
            ]}
          />
        );
      });
  };

  const accountApproval = () => {
    (async () => {
      setShowLoader();
      toast.dismiss();
      UniversalRefreshToast("approvalaccountsRefresh");
      let response = await dispatch(approveBeneficiaryAccount({ id }));
      if (approveBeneficiaryAccount.fulfilled.match(response)) {
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          variant: "var(--success)",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        });

        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.beneficiary_account?.[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        });
      }
    })();
  };

  const accountRejected = () => {
    (async () => {
      setShowLoader();
      toast.dismiss();
      UniversalRefreshToast("accountsRefresh");
      let response = await dispatch(
        rejectBeneficiaryAccount({
          id,
          rejection_reason: declineReason,
        }),
      );
      if (rejectBeneficiaryAccount.fulfilled.match(response)) {
        toast.dismiss();
        CommonToast({
          text: "Beneficiary account rejected.",
          variant: "var(--success)",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        });

        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.beneficiary_account?.[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        });
        setRejectPopup(false);
      }
    })();
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };
  const buttonRows = [
    ...(services?.includes("BAAccount") || services?.includes("Admin")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),
    [
      // {
      //   btnText: "Switch account type",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS?.CREATE_NEW_ACCOUNT,
      //   handleFunction: switchAccountType,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  const chipsArray = [
    {
      text: "Reimbursement account",
      icon: ICONS?.REIMBURSEMENT_ACCOUNTS_WITH_BLUE_CIRCLE,
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: false,
      hoverOption: "blue",
      bulletPoint: [
        "This account will require approval after switching.",
        "Linking a user is required for this account.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    // {
    //   text: "Field force account",
    //   icon: ICONS?.FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE,
    //   selected: selectedChipIndex === GlobalConfiguration?.lengthCheckTwo,
    //   disabled: false,
    //   hoverOption: "blue",
    //   onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
    //   bulletPoint: [
    //     "This account will require approval after switching.",
    //     "Linking a user is required for this account.",
    //   ],
    // },
  ];

  const handleApply = (index) => {
    setShowSwitchAccountModal(false);
    if (index === GlobalConfiguration?.lengthCheckZero) {
      navigate(
        `/reimbursement_account_dashboard/create_reimbursement_account`,
        {
          replace: true,
          state: {
            ...currentAccountDetails,
            type: "switch_account",
          },
        },
      );
    } else {
      CommonToast({
        text: "Feature coming soon",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--coming-soon)",
        buttonNeeded: false,
      });
    }
    setSelectedChipIndex(null);
  };

  return (
    <>
      {showSwitchAccountModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            headerTitle="Select the type of account you want to switch to"
            chipsArray={chipsArray}
            btnOneBtnType="button"
            btnOneHandleFunction={() => {
              setShowSwitchAccountModal(false);
              setSelectedChipIndex(null);
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Next"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => {
              handleApply(selectedChipIndex);
            }}
            btnTwoIsDisabled={selectedChipIndex === null}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
            activeAccountType={true}
          />
        </div>
      )}

      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex">
          <div className="absolute top-top-base left-top-base h-full w-full opacity-dark-opacity bg-PopUp-BackDrop" />
          <SmallPopupWithInput
            headerTitle="Reject account"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteColor="text-secondary"
            bulletPoints={[
              "New requests and transactions cannot be created for this account.",
              "Before rejecting this account, reject all associated transactions and requests.",
              "Users can edit the rejected account to update details.",
            ]}
            subtextwithbullet="Y"
            inputPlaceholder={"Reason"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            noteText="Minimum 10 characters required."
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              setShowLoader(true);
              accountRejected();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <div>
        <StatusContainer
          status="success"
          buttonRows={buttonRows}
          title={
            "Old account archived and new account added to the list of active beneficiary accounts successfully."
          }
        >
          <TabsWeapperSection title="Updated details">
            <>
              {renderBankCards()}
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneAccountSuccessData?.id || "NA",
                    leftSubTitle: "Account ID",
                    copyText: beneAccountSuccessData?.id || "NA",
                  },
                ]}
              />
            </>
          </TabsWeapperSection>
          {panLookupData?.beneficiary_accounts.length >
            GlobalConfiguration.lengthCheckOne && (
            <TabsWeapperSection title="Accounts associated to PAN">
              {panLookupData?.beneficiary_accounts
                ?.filter(
                  (beneAccountSuccessData) =>
                    beneAccountSuccessData?.approval_status === "pending" ||
                    beneAccountSuccessData?.approval_status === "approved",
                )
                .map((beneAccountSuccessData, id) => (
                  <InfoCard
                    key={id}
                    bgColor="var(--positive-card)"
                    showRowDivider={true}
                    rowBorderColor="var(--positive-bg)"
                    rows={[
                      {
                        leftTitle:
                          accountNameStandardised(
                            beneAccountSuccessData?.bank_account_holder_full_name,
                          ) || "Not available",
                        leftSubTitle: `${
                          beneAccountSuccessData?.approval_status
                            ?.charAt(0)
                            .toUpperCase() +
                          beneAccountSuccessData?.approval_status?.slice(1)
                        } account`,
                      },
                      {
                        leftTitle: beneAccountSuccessData?.bank_acc_no,
                        leftSubTitle: "Bank account number",
                        ifsc: beneAccountSuccessData?.ifsc_code,
                      },
                    ]}
                  />
                ))}
            </TabsWeapperSection>
          )}

          {bankLookupData?.beneficiary_accounts?.length >
            GlobalConfiguration.lengthCheckOne && (
            <TabsWeapperSection title="Accounts Associated to Bank">
              {bankLookupData?.beneficiary_accounts
                .filter(
                  (beneAccountSuccessData) =>
                    beneAccountSuccessData?.approval_status === "pending" ||
                    beneAccountSuccessData?.approval_status === "approved",
                )
                .map((beneAccountSuccessData, id) => (
                  <InfoCard
                    key={id}
                    bgColor="var(--positive-card)"
                    showRowDivider={true}
                    rowBorderColor="var(--positive-bg)"
                    rows={[
                      {
                        leftTitle:
                          accountNameStandardised(
                            beneAccountSuccessData?.name,
                          ) || "Not available",
                        leftSubTitle: `${
                          beneAccountSuccessData?.approval_status
                            ?.charAt(0)
                            .toUpperCase() +
                          beneAccountSuccessData?.approval_status?.slice(1)
                        } account`,
                      },
                      {
                        leftTitle: beneAccountSuccessData?.pan_no,
                        leftSubTitle: "PAN number",
                      },
                    ]}
                  />
                ))}
            </TabsWeapperSection>
          )}
        </StatusContainer>
      </div>
    </>
  );
}

export default ReimbursementBankEditSucess;
